import { applyMiddleware, combineReducers, compose, createStore as _createStore } from 'redux';
import thunk from 'redux-thunk';
import {
  abUseExperimentsReducer,
  consultantContactsReducer,
  locationReducer,
  notificationsReducer,
  pageStateReducer,
  seoDataReducer,
  userReducer,
} from '../../reducers';
import { analyticsReducer } from '../../reducers/analytics';
import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, IInitialApplicationState, TReduxActions, TReduxStore } from '../../types/redux';

let storeReminder: TReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IInitialApplicationState - предзагруженное состояние
 */
export function createReduxStore(
  initialState: IInitialApplicationState,
  context: IApplicationContext,
  debugEnabled: boolean,
) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    abUseExperiments: abUseExperimentsReducer,
    analytics: analyticsReducer,
    consultantContacts: consultantContactsReducer,
    location: locationReducer,
    notifications: notificationsReducer,
    pageState: pageStateReducer,
    seoData: seoDataReducer,
    user: userReducer,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(applyMiddleware(thunk.withExtraArgument(context)));

  const createStore = (): TReduxStore =>
    _createStore<IInitialApplicationState, TReduxActions, {}, IApplicationState>(
      reducers,
      initialState,
      storeEnchancers,
    );

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
